export default __webpack_public_path__ + "static/media/travel-icon.1b5ec59c.svg";